/* eslint-disable eol-last */
/* eslint space-before-function-paren: ["error", "never"] */
/*07-01-2019 */

import $ from "jquery";
import "bootstrap";
import "slick-carousel";
import "jquery.easing";
import "dropkickjs";
import "lazysizes";
import "easyzoom";
import * as map from "./vendor/maps.js";
import {
  debuggerStatement
} from "babel-types";
import {
  isNull
} from "util";
var $inicio = true;

// Slick carousel
$(".homeSlider").slick({
  dots: true,
  autoplay: true,
  arrows: true,
  pauseOnHover: false,
  appendDots: ".home-slideshow",
  appendArrows: ".home-slideshow",
  prevArrow: '<span class="fa fa-angle-left abs-center-y prev control"></span>',
  nextArrow: '<span class="fa fa-angle-right abs-center-y next control"></span>'
});

$(".collectionSlider").slick({
  dots: true,
  autoplaySpeed: 4000,
  autoplay: true,
  arrows: true,
  pauseOnHover: false,
  prevArrow: '<span class="fa fa-angle-left abs-center-y prev control"></span>',
  nextArrow: '<span class="fa fa-angle-right abs-center-y next control"></span>'
});

$(".productSlider").slick({
  dots: false,
  centerMode: true,
  centerPadding: "20%",
  infinite: false,
  slidesToShow: 1,
  autoplay: false,
  arrows: true,
  pauseOnHover: false,
  infinite: false,
  prevArrow: '<span class="fa fa-angle-left abs-center-y prev control"></span>',
  nextArrow: '<span class="fa fa-angle-right abs-center-y next control"></span>'
});

function checkUrlHash() {
  var hash = window.location.hash;

  if (hash === "#recover") {
    $("#RecoverPasswordForm").removeClass("d-none");
    $("#CustomerLoginForm").addClass("d-none");
  } else {
    $("#RecoverPasswordForm").addClass("d-none");
    $("#CustomerLoginForm").removeClass("d-none");
  }
}

checkUrlHash();

// Show reset password form
$("#recover").on("click", function (evt) {
  evt.preventDefault();
  $("#RecoverPasswordForm").removeClass("d-none");
  $("#CustomerLoginForm").addClass("d-none");
  window.location.hash = $(this).attr("id");
});

// Hide reset password form
$("#HideRecoverPasswordLink").on("click", function (evt) {
  evt.preventDefault();
  $("#RecoverPasswordForm").addClass("d-none");
  $("#CustomerLoginForm").removeClass("d-none");
  window.location.hash = "";
});

// Customer add address

// Check URL for reset password hash
function checkUrlAddress() {
  const hash = window.location.hash;
  if (hash === "#add-address") {
    $("#CustomerAddAddressForm").removeClass("d-none");
    $("#CustomerAddressForm").addClass("d-none");
  } else {
    $("#CustomerAddAddressForm").addClass("d-none");
    $("#CustomerAddressForm").removeClass("d-none");
  }
}

checkUrlAddress();

// Show reset password form
$("#add-address").on("click touchstart", function (evt) {
  evt.preventDefault();
  $("#CustomerAddAddressForm").removeClass("d-none");
  $("#CustomerAddressForm").addClass("d-none");
  window.location.hash = $(this).attr("id");
});

// Hide reset password form
$("#HideAddressAdder").on("click touchstart", function (evt) {
  evt.preventDefault();
  $("#CustomerAddAddressForm").addClass("d-none");
  $("#CustomerAddressForm").removeClass("d-none");
  window.location.hash = "";
});

// send request as a POST
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

$(".address-delete").on("click", function () {
  var $el = $(this);
  var formId = $el.data("form-id");
  var confirmMessage = $el.data("confirm-message");

  if (confirm(confirmMessage)) {
    Shopify.postLink("/account/addresses/" + formId, {
      parameters: {
        _method: "delete"
      }
    });
  }

  return false;
});

// Cart

if ($("body").hasClass("template-cart") === true) {
  $("body").on("click touchstart", ".btn-submit", function () {
    if ($("#agree").is(":checked")) {
      $(this).submit();
    } else {
      $(".summary .alert").removeClass("d-none");
      return false;
    }
  });
  $("body").on("click click", ".custom-checkbox", function () {
    $(".summary .alert").addClass("d-none");
  });
}

// Submenu dropbdown

$(document).on(
  "mouseover touchstart",
  '.navbar li.dropdown:not(".show")',
  function () {
    $(".navbar li.dropdown.show")
      .children(".dropdown-menu")
      .slideUp({
        duration: 400,
        easing: "easeOutQuart"
      });
    $(this)
      .addClass("show")
      .children(".dropdown-menu")
      .stop(true, true)
      .delay(100)
      .slideDown({
        duration: 400,
        easing: "easeOutQuart"
      });
  }
);

$(document).on("mouseout touchstart", ".navbar li.dropdown.show", function () {
  $(this)
    .removeClass("show")
    .children(".dropdown-menu")
    .stop(true, true)
    .delay(100)
    .slideUp({
      duration: 400,
      easing: "easeOutQuart"
    });
});

// Search autocomplete

$(function () {
  var currentAjaxRequest = null;
  var searchForms = $('header form[action="/search"]')
    .css("position", "relative")
    .each(function () {
      var input = $(this).find('input[name="q"]');
      var offSet = input.position().top + input.innerHeight() + 2;

      $('<ul class="search-results"></ul>')
        .css({
          position: "absolute",
          left: "0px",
          top: offSet
        })
        .appendTo($(this))
        .fadeOut();

      input.attr("autocomplete", "off").bind("keyup change", function () {
        var term = $(this).val();
        var form = $(this).closest("form");
        var searchURL = "/search?type=product&q=" + term;
        var resultsList = form.find(".search-results");
        if (term.length > 2 && term !== $(this).attr("data-old-term")) {
          $(this).attr("data-old-term", term);
          searchForms.addClass("loading");
          if (currentAjaxRequest !== null) currentAjaxRequest.abort();
          currentAjaxRequest = $.getJSON(searchURL + "&view=json", function (
            data
          ) {
            resultsList.empty();
            if (data.results_count === 0) {
              searchForms.removeClass("loading");
              // resultsList.html(
              //   '<li class="p-0"><span class="small">No hay resultados para la búsqueda.</span></li>'
              // );
              // resultsList.fadeIn(200);
              resultsList.fadeOut();
            } else {
              searchForms.removeClass("loading");
              $.each(data.results, function (index, item) {
                var link = $("<a></a>").attr("href", item.url);
                link.append(
                  '<span class="thumbnail"><img src="' +
                  item.thumbnail +
                  '" /></span>'
                );
                link.append('<span class="title">' + item.title + "</span>");
                link.wrap("<li></li>");
                resultsList.append(link.parent());
              });

              if (data.results_count > 10) {
                searchForms.removeClass("loading");
                resultsList.append(
                  '<li><span class="title"><a href="' +
                  searchURL +
                  '">Ver todos los resultados (' +
                  data.results_count +
                  ")</a></span></li>"
                );
              }
              resultsList.fadeIn(200);
            }
          });
        }
      });
    });
});

$("body").bind("click", function () {
  $(".search-results").fadeOut();
});

// COLLECTION SWATCHES

const $clSwatch = $(".collection-swatches > a");

$clSwatch.on("mouseenter", function () {
  const $this = $(this);
  const $imgSrc = $(this).data("image");
  const $image2 = $this.parents(".card-product").find(".card-product__image");
  $this.addClass("active");
  $this.siblings().removeClass("active");
  $image2.attr("src", $imgSrc);
});

// PHOTO CAPTION
const $caption = $(".photo-caption");
const $captionIcon = $(".photo-caption__icon");
const $captionText = $(".photo-caption__text");

$caption.on("mouseenter touchstart", function () {
  const $this = $(this);
  $captionIcon.fadeOut();
  $this.find($captionText).fadeIn();
});

$captionText.on("mouseout touchstart", function () {
  const $this = $(this);
  $captionIcon.fadeIn();
  $this.fadeOut();
});

// MINI CART
const $cartWrapper = $(".mini-cart");
const $cart = $(".mini-cart-products");
const $cartCount = $(".cart-count");

function currencyFormat(myAmount) {
  var amount = myAmount / 100;
  return "$" + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function getProducts(content, productsQty, totalPrice, linePrice, quantity) {
  if (productsQty > 0) {
    //console.log('getProducts' + content, productsQty, totalPrice, );
    $cartCount.text(productsQty);
    $(".mini-cart-totals .price").text(currencyFormat(totalPrice));

    content.forEach(function (e) {
      var $cropImage = () => {
        //var file = e.image.replace('.jpg', '_100x100_crop_center.jpg');
        var file = e.properties.image;
        return file;
      };

      var $image = $cropImage();

      if (e.id != null) {
        $cart.append(`<div class="mini-cart_product d-flex" id="product-${
          e.product_id
        }">
            <div class="image-wrapper">
              <img class="img-fluid" src="${$image}" alt="
              ${e.product_title}" width="60" height="60">
            </div>
            <div class="col p-0 pl-2">
              <div class="name avenir-bold h6 m-0">
                <a href="${e.url}">
                  ${e.product_title}
                </a>
              </div>
              <div class="vary pb-1">${e.variant_title}</div>
              <div class="price d-flex">
                <div class="qty">
                ${e.quantity}
                <span class="text-gray d-inline-block pr-3 pl-2">x</span></div>
                <div class="price">${currencyFormat(e.line_price)}</div>
              </div>
            </div>
          </div>`);
      }
    });
  }
}

function loadCart() {
  $.ajax({
    cache: false,
    url: "/cart.json",
    type: "get",
    dataType: "json",
    success: function (response) {
      var items = response.items;
      var count = response.item_count;
      var priceCart = response.total_price;
      getProducts(items, count, priceCart, items.line_price, items.quantity);
    },
    error: function (ms, textStatus, errorThrown) {
      $cartWrapper.remove();
      console.log(errorThrown);
    }
  });
}

loadCart();

// Video in collection responsive

(() => {
  $("iframe").wrap(
    "<div class='embed-responsive embed-responsive-16by9 mb-6'></div>"
  );
})();

// Go top button appear on scroll

const $collectionWrapper = $("#collection-load");
const $gotopBtn = $(".back-to-top");
var $id = $gotopBtn.attr("href");

$(window).on("scroll touchmove", function () {
  if ($(window).scrollTop() > $($collectionWrapper).height() * 0.5) {
    $gotopBtn.addClass("active");
  } else {
    $gotopBtn.removeClass("active");
  }
});

$gotopBtn.on("click touchstart", e => {
  $("html, body").animate({
      scrollTop: $($id).offset().top - 100
    },
    "slow"
  );
  return false;
});

/* ==============================================================================
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxify v1.0
https://github.com/Elkfox/Ajaxify
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
Project lead: George Butter
MIT License
============================================================================== */

const $urlHandle = $(".url-handle");
const $sortHandle = $(".sort-handle");
const $baseUrl = window.location.protocol + "//" + window.location.hostname;

function ajaxify(settings) {
  settings = settings || {};
  var linkParent = settings.linkParent || ".pagination";
  var parentContainer = settings.parentContainer || "#collection-load";
  var endlessScrollContainer =
    settings.endlessScrollContainer || ".EndlessScroll";
  var endlessOffset = settings.endlessOffset || 0;
  var ajaxinateContainer = settings.ajaxinateContainer || $collectionWrapper;
  var fade = settings.fade || "fast";
  const callback = settings.callback || false;

  var linkElem;
  var contentContainer;
  var pageNumber;
  var pageType;
  var action;
  var moreURL;

  function loadMore() {
    if (moreURL.length) {
      $.ajax({
        type: "GET",
        dataType: "html",
        url: moreURL,
        success: function (data) {
          if (pageType === "ajax") {
            $(ajaxinateContainer)
              .not('[data-page="' + pageNumber + '"]')
              .hide();
            history.pushState({}, pageNumber, moreURL);
          } else {
            $(linkElem).fadeOut(fade);
          }
          var filteredData = $(data).find(contentContainer);
          $(filteredData)
            .appendTo($(contentContainer).parent())
            .hide()
            .fadeIn(fade);
          if (pageType === "endlessScroll") {
            endlessScroll();
          }
          $(document).trigger("ajaxify:updated", [data]);
          if (callback && typeof callback === "function") {
            callback(data);
          }
        }
      });
    }
  }

  // Check whether the page is at the bottom

  function endlessScroll() {
    action = "scroll load resize";
    $(window).on(action, function () {
      contentContainer = endlessScrollContainer;
      moreURL = $(contentContainer + ":last-of-type " + linkElem).attr("href");
      pageType = "endlessScroll";
      if ($(contentContainer + ":last-of-type " + linkElem).length) {
        var bottom = $(parentContainer).outerHeight();
        var docTop =
          $(document).scrollTop() + $(window).height() + endlessOffset;
        if (docTop > bottom) {
          $(window).off(action);
          loadMore();
        }
      }
    });
  }

  // Endless Scroll Initialize
  if ($(endlessScrollContainer).length) {
    linkElem = linkParent + " a";
    endlessScroll();
  }
}

ajaxify();

// CUSTOM SELECT

$(".select").dropkick({
  mobile: true
});

// FILTER SIDEBAR

$(".link-filter").on("click touchstart", function (e) {
  if ($(this).hasClass("active-filter")) {
    $(this).removeClass("active-filter");
  } else {
    $(".sidebar .link-filter").removeClass("active-filter");
    $(this).addClass("active-filter");
  }

  e.preventDefault();

  var collectionUrl = "/collections/" + $(this).attr("data-collection");
  var filterString = "";

  $(".active-filter").each(function () {
    filterString += $(this).attr("data-filter") + "+";
  });
  filterString = filterString.substring(0, filterString.length - 1);

  var url =
    $baseUrl +
    collectionUrl +
    "/" +
    filterString +
    "?sort_by=" +
    $sortHandle.val();

  $urlHandle.val(collectionUrl + "/" + filterString);

  $.ajax({
    type: "GET",
    dataType: "html",
    cache: false,
    url: url,
    complete: function (data) {
      var filteredData = $(data.responseText).find(".EndlessScroll");
      $(".load-mask").hide();
      $("#collection-load")
        .empty()
        .html(filteredData[0]);
    }
  });
  return false;
});

// SORT BY SELECT

function sortAjax(t) {
  var $sortHandleVal = t;
  var $urlHandleVal = $urlHandle.val();
  var $sortUrl = $baseUrl + $urlHandleVal + "/?sort_by=" + $sortHandleVal;

  $(".load-mask").show();

  $.ajax({
    type: "GET",
    dataType: "html",
    cache: false,
    url: $sortUrl,
    complete: function (data) {
      var filteredData = $(data.responseText).find(".EndlessScroll");
      $(".load-mask").hide();
      $("#collection-load")
        .empty()
        .html(filteredData[0]);
    }
  });
}

$("#sort-by").bind("change", function () {
  sortAjax($(this).val());
});

// SORT BY CLICK

$("#filter-sort a").on("click touchstart", function (e) {
  e.preventDefault();
  sortAjax($(this).data("value"));
  $(this).addClass("link");
  $(this)
    .siblings()
    .removeClass("link");
  $(this)
    .parent(".tab-pane")
    .removeClass("active show");
  $("#filter-sort-tab").removeClass("active show");
});

// FILTER TAB MOBILE

$("#filter-tab a").click(function (e) {
  e.preventDefault();
  if ($(this).hasClass("active")) {
    var $href = $(this).attr("href");
    $(this)
      .tab()
      .removeClass("active show")
      .attr("aria-expanded", "false");
    $($href).removeClass("active show");
  } else {
    $(this).tab("show");
  }
});

// Easy zoom on product image

var $easyzoom = $(".zoom").easyZoom();

const $featuredImgId = $(".variant-image-id").data("imageid");
const $thumbnails = $(".thumbnails");

function RecuperaVariante(i) {
  const $slide = $(".productSlider [data-slick-index=" + i + "]");
  const $slideId = $slide.find(".item").data("image-id");
  const $Count = $slide.find(".item").data("count");
  //entrega el color seleccionado en la imagen (campo Alt)
  const $slideAlt = $slide.find(".img-filter").data("image-id");
  var $slideAlt2 = $slideAlt.toString().trim();
  var $size = $(".product-size").text().toString().trim().toUpperCase();
  var $color;
  var $colorYtalla;
  // console.log($slide + ' ' + $slideId + ' ' + $slideAlt);

  $(".colorSelected").each(function () {
    $color = $(this)
      .val()
      .toString()
      .trim();
    if ($color === $slideAlt2) {
      // console.log('color: ' + $color + ' slide' + $slideAlt2);
      $("#nameColor").text($(this).val());
      $(this).val($color);
      $(this).attr("checked", "checked");
      $(".color-index").val($(this).attr("name"));
      $(".url-color").val(
        $('.thumbnails li[data-id="' + $slideId + '"] img').attr("src")
      );
    } else {
      $(this).attr("checked", "");
    }
  });

  var talla = "unica";

  if ($size != talla.toUpperCase()) {
    $colorYtalla = $slideAlt2 + " / " + $size;
  } else {
    $colorYtalla = $slideAlt2 + " / TALLA UNICA";
  }

  //console.log("Talla: " + $colorYtalla);
  // Aqui encuentro el option que tiene la misma talla y color
  let $option = $('.multi_select option[data-color="' + $colorYtalla + '"]');
  let $variante = $option.val();
  let $sku = $option.data("sku");
  let $inv = $option.data("inv");
  var disp = "";

  if (parseInt($inv) == 1) {
    disp = "Queda 1 artículo disponible";
  } else if (parseInt($inv) < 6) {
    disp = "Quedan " + $inv + " artículos disponibles";
  }

  //addToCartDone
  $(".variant-id").val($variante);
  $(".variant-id").data("id", $variante);
  $(".variant-image-id").attr("value", $slideId);
  $(".variant-image-id").data("imageid", $slideId);
  $(".sku .number").text($sku);
  $(".qty-left").text(disp);

  var sizee;
  //la Clase .tallaElegir está vacía, solo se colocó para poder llamar al objeto.
  $(".tallaElegir").each(function () {
    sizee = $(this).data("value").toString().trim().toUpperCase();
    let $option2 = $('.multi_select option[data-color="' + $slideAlt2 + " / " + sizee + '"]');
    let $inv2 = $option2.data("inv");

    //console.log("Talla: " + $(this).data("value") + " Stock " + $inv2);

    if (parseInt($inv2) > 0) {
      $(this).removeClass("nostock");
      $(".submit-cart").removeClass("disabled").removeClass("disable").text("Agregar");
      $inicio = false;
      //console.log("después: " + $slideAlt2 + $inv2 + " " + $(this).attr("class"));
    } else {
      $(this).addClass("nostock");
    }
  });
  // console.log('RecuperaVariante index ' + i + ' variantes ' + $variante + ' ' + ' color ' + $slideAlt2 + ' talla ' + $size + ' sku ' + $sku);
}

// funcion para active de thumbnails
// Change slide product on load page
function onChangeProductCarousel() {
  $(".productSlider").on("afterChange", function (event, slick, currentSlide) {
    const $currentSlide = currentSlide;
    const $slide = $(".productSlider [data-slick-index=" + $currentSlide + "]");
    const $slideId = $slide.find(".item").data("image-id");
    // console.log('ProductCarousel ' + currentSlide, $slideId);
    $thumbnails.find(".active").removeClass("active");
    $thumbnails.children("li[data-id=" + $slideId + "]").addClass("active");

    RecuperaVariante($currentSlide);
  });
}

// para ejecutar goto de slick t cambia el carousel
function changeSlide(index) {
  const $slide = $('.productSlider .item[data-image-id="' + index + '"]');
  const $slideIndex = $slide.parents(".slick-slide").data("slick-index");
  onChangeProductCarousel();
  //console.log("changeSlide " + index);
  $(".productSlider").slick("slickGoTo", $slideIndex);
}

if (document.body.className.match("template-product")) {
  const JSONData = $productJson;
  const productID = $(".product_form").data("product-id");
  const productSection = ".product-" + productID + " .js-product_section";
  const swatchOptions = $(".product_form").find(".swatch_options .swatch");

  changeSlide($featuredImgId);

  $("#filter-tab").on("show.bs.tab", function () {
    if (swatchOptions.length) {
      Shopify.linkOptionSelectors(JSONData, productSection);
    }
  });
}

// Change slick slider on click thumbnails
$(".thumbnails li").on("click touchstart", function (e) {
  const $dataID = $(this).data("id");
  changeSlide($dataID);

  return false;
});

// ADD TO CART WITH AJAX

const $submit = $(".submit-cart");
// const $cartItem = $('.minicart-menu .item-icon');
const $cartLink = $(".minicart-menu .item-icon a");
// const $cartCounter = $('.minicart-menu .item-icon .cart-count');
// const $cartCounterVal = $('.minicart-menu .item-icon .cart-count').text();
const $modalAddedContent = $("#addedModal .product-details");

function showModalAdded() {
  $("#addedModal").modal("show");
  setTimeout(function () {
    $("#addedModal").modal("hide");
    $modalAddedContent.empty();
  }, 3000);
}

function beforeAddToCart() {
  $submit.addClass("loading");
  $submit.attr("disabled", "disabled").addClass("disabled");
  $modalAddedContent.addClass("loading");
}

function addToCartOk(product) {
  $submit.removeAttr("disabled").removeClass("disabled loading");
  $cartLink.addClass("current");
  $(".minicart-menu .no-items").addClass("d-none");
  $(".minicart-menu .content-form").removeClass("d-none");
  $modalAddedContent.removeClass("loading");
}

function addToCartFail(XMLHttpRequest) {
  var response = eval("(" + XMLHttpRequest.responseText + ")");
  response = response.description;
  $submit.removeAttr("disabled").removeClass("disabled loading");
  $modalAddedContent.append("contenido");
  $modalAddedContent.removeClass("loading").empty();
  $modalAddedContent.html(
    `<div class="avenir-bold-it mb-0 lh-12 text-center my-5">${response}</div>`
  );
  showModalAdded();
}

function addToCartDone(e) {
  //función original

  var $cropImage = () => {
    //var file = e.image.replace('.jpg', '_300x300_crop_center.jpg');
    var file = e.properties.image.replace("100x100", "300x300");
    return file;
  };
  var $image = $cropImage();
  $modalAddedContent.removeClass("loading").empty();
  $modalAddedContent.html(`<div class="d-flex" id="product-${e.product_id}">
    <div class="image-wrapper">
      <img class="img-fluid" src="${$image}" alt="${
    e.product_title
  }" width="150" height="150">
    </div>
    <div class="col p-0 pl-4">
      <div class="title avenir-bold h5 text-secondary mb-1 text-uppercase">
          Agregado al carro:
      </div>
      <div class="name h5">
          ${e.product_title}
      </div>
      <div class="vary">${e.variant_title}</div>
      <div class="price d-flex">
        <div class="qty">
        ${e.quantity}
        <span class="text-gray d-inline-block pr-3 pl-2">x</span></div>
        <div class="price">${currencyFormat(e.line_price)}</div>
      </div>
      <form action="/cart" method="post">
        <input type="submit" class="btn btn-secondary mt-2 btn-sm" value="Ver bolsa de compras">
      </form>
    </div>
  </div>`);

  showModalAdded();
  $cart.empty();
  loadCart();
}

function addItemToCart() {
  const $qty = $(".product-qty").text();
  const $id = $(".variant-id").val();
  const $img = "https:" + $(".url-color").val();
  //console.log('addItemToCart' + $qty, $id);
  // modItemToCart();
  $.ajax({
    url: "/cart/add.js",
    dataType: "json",
    type: "post",
    data: {
      quantity: $qty,
      id: $id,
      properties: {
        image: $img
      }
    },
    beforeSend: beforeAddToCart,
    success: addToCartOk,
    error: addToCartFail
  }).done(addToCartDone);
}

$(".submit-cart").on("click", function () {
  if ($(this).hasClass("disable")) return false;
  else addItemToCart();
});

// Swatch options based on patagonia.com.au

Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  //console.log("updateOptionsInSelector: " + selectorIndex, parent);
  switch (selectorIndex) {
    case 0:
      var key = "root";
      var selector = $(parent + " .single-option-selector:eq(0)");
      break;
    case 1:
      var key = $(parent + " .single-option-selector:eq(0)").val();
      var selector = $(parent + " .single-option-selector:eq(1)");
      break;
    case 2:
      var key = $(parent + " .single-option-selector:eq(0)").val();
      key += " / " + $(parent + " .single-option-selector:eq(1)").val();
      var selector = $(parent + " .single-option-selector:eq(2)");
  }

  var initialValue = selector.val();
  selector.empty();
  var availableOptions = Shopify.optionsMap[key];
  if (availableOptions) {
    for (var i = 0; i < availableOptions.length; i++) {
      var option = availableOptions[i];
      var newOption = $("<option></option>")
        .val(option)
        .html(option);
      selector.append(newOption);
    }
  }

  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function () {
    if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
      $(this).removeClass("outline");
      $(this).removeClass("nostock");
    } else {
      if ($inicio) {
        $(this).addClass("nostock");
      }
    }
  });

  const $firstAvailable = $(
    parent + ' .swatch[data-option-index="1"] .swatch-element'
  ).not("outline");
  if ($firstAvailable.first().hasClass("active")) {
    $(this).removeClass("active");
  } else {
    $(this).addClass("active");
  }
  if ($.inArray(initialValue, availableOptions) !== -1) {
    selector.val(initialValue);
  } else {
    selector.val(initialValue);
  }
  selector.trigger("change");
};

Shopify.linkOptionSelectors = function (product, parent) {
  Shopify.optionsMap = {};
  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
      Shopify.optionsMap["root"].push(variant.option1);
      Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      if (product.options.length === 3) {
        var key = variant.option1 + " / " + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }
  Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) {
    Shopify.updateOptionsInSelector(1, parent);
  }
  if (product.options.length === 3) {
    Shopify.updateOptionsInSelector(2, parent);
  }
  $(parent + " .single-option-selector:eq(0)").change(function () {
    Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) {
      Shopify.updateOptionsInSelector(2, parent);
    }
    return true;
  });
  $(parent + " .single-option-selector:eq(1)").change(function () {
    if (product.options.length === 3) {
      Shopify.updateOptionsInSelector(2, parent);
    }
    return true;
  });
};

$(document).on("change", ".swatch :radio", function () {
  var optionIndex = $(this)
    .parents(".swatch")
    .attr("data-option-index");
  var optionValue = $(this).val();
  $(this)
    .parents(".product_form")
    .find(".single-option-selector")
    .eq(optionIndex)
    .val(optionValue)
    .trigger("change");
});

$(document).on("change", ".colorSelected", function () {
  var optionSlide = $(this).attr("name");
  optionSlide--;
  var imgId = $(".thumbnails li:eq(" + optionSlide + ")").data("id"); //imgId es el valor indice de la imagen
  console.log("colorSelected data-id:" + imgId);
  changeSlide(imgId);
});

$(document).on("change", ".sizeSelected", function () {
  var optionSlide = $(".color-index").val();
  optionSlide--;
  var imgId = $(".thumbnails li:eq(" + optionSlide + ")").data("id");
  //console.log("sizeSelected variante-id: " + imgId);
  changeSlide(imgId);

});
var selectCallback = function (variant, selector) {
  //console.log("Var: " + variant, "SEL: " + selector);
  //console.log(variant.available);
  if (!isNull(variant))
    if (variant && variant.available) {
      $(".sku .number").text(variant.sku);
      $(".submit-cart")
        .removeClass("disabled")
        .removeClass("disable")
        .text("Agregar");
      $(".price-wrapper .price")
        .html(currencyFormat(variant.price))
        .removeClass("d-none");
      $(".variant-id")
        .attr("data-id", variant.id)
        .val(variant.id);
      $(".product-size").text(variant.option2);
      if (variant.price < variant.compare_at_price) {
        $(".price-wrapper .discount").remove();
        $(".price-wrapper .price").after(
          '<span class="discount pl-2">' +
          currencyFormat(variant.compare_at_price) +
          "</span>"
        );
        $(".price-wrapper .price").addClass("price-descuento");
      } else {
        $(".price-wrapper .discount").remove();
        $(".price-wrapper .price").removeClass("price-descuento");
      }
    } else {
      //console.log("LOG: " + variant);
      $(".submit-cart")
        .removeClass("disabled")
        .text("Agotado")
        .addClass("disable");
      $(".price-wrapper .price").css("opacity", "0");
    }
};

$(document).ready(function () {
  if ($(".js-product_section").length) {
    let sortedProds = [];
    // console.log($productJson);

    $productJson.variants.forEach(function (variant, i) {
      if (variant.available) {
        sortedProds.push(variant);
      }
    });
    $productJson.variants.forEach(function (variant, i) {
      if (!variant.available) {
        sortedProds.push(variant);
      }
    });

    $productJson.variants = sortedProds;

    new Shopify.OptionSelectors(
      $(".js-product_section .product_form_options").data("select-id"), {
        product: $productJson,
        onVariantSelected: selectCallback,
        enableHistoryState: $(this).data("enable-state")
      }
    );
  }

  $("#filter-tabContent #filter-size a:contains('talla-unica')").text("unica");

  //en el texto del selct (dropdown)
  delaySetTallaUnica();

  // cambia el valor del dropdown cuando se hace click en el dropdown
  $("#filter-tab li.nav-item a").click(function (evt) {
    delaySetTallaUnica();
  });

  // cambia el valor del dropdown cuando se selecciona una opcion del listado
  $("#filter-tabContent a").click(function () {
    delaySetTallaUnica();
  });

  // Esto hardcodea el cuadrito: Mochilas y equipamiento
  // Esto le quita los guiones a los cuadritos:
  $(".collection-wrapper a span.name").each(function () {
    this.textContent = this.textContent.replace(/-/g, " ");
  });

  $("#heading-tablas-de-surf a span.name").each(function () {
    this.textContent = this.textContent.replace(/-/g, " ");
  });


  // Cambia texto Search Result
  // $(".page-title").text("Resultados de Búsqueda");

  // Cambia texto de los filtros en el dropdown
  $(".menu-trigger").text("Seleccione");
});



// en el texto del selct (dropdown)
function delaySetTallaUnica() {
  setTimeout(function () {
    $("#filter-size-tab span.selected:contains('Talla unica')").text("unica");
  }, 50);
  setTimeout(function () {
    $("#filter-size-tab span.selected:contains('TALLA UNICA')").text("unica");
  }, 50);
}

function closeOptions() {
  setTimeout(function () {
    $(
      ".template-product .nav-tabs-product .nav-link, .tab-options"
    ).removeClass("show active");
  }, 400);
}

$(document).on("click touchstart", "#filter-qty a", function () {
  const $val = $(this).data("value");
  $(".product-qty").text($val);
  closeOptions();
  return false;
});

$(document).on("click touchstart", ".swatch-element", function () {
  const swatchValue = $(this).data("value");
  const JSONData = $productJson;
  const productID = $(this)
    .parents(".product_form")
    .data("product-id");
  const productSection = ".product-" + productID + " .js-product_section";
  const swatchOptions = $(this)
    .parents(".product_form")
    .find(".swatch_options .swatch");
  const $parentid = $(this)
    .parents(".tab-pane")
    .attr("id");
  const $selectedTab = $parentid + "-tab";
  const $selected = $(this).data("value");

  var swatchValue2 = swatchValue.toString().toUpperCase();
  //console.log('swatchValue' + encodeURI(swatchValue));

  $(this)
    .addClass("active")
    .next('input[value="' + encodeURI(swatchValue2) + '"]')
    .prop("checked", true)
    .trigger("change");

  $(this)
    .siblings(".swatch-element")
    .removeClass("active");

  $("#" + $selectedTab)
    .find(".selected")
    .text($selected);

  if (swatchOptions.length) {
    Shopify.linkOptionSelectors(JSONData, productSection);
  }

  closeOptions();
  return false;
});

$(".template-product .product-options").on("mouseleave", function () {
  closeOptions();
});

// UPDATE CART PRODUCTS QUANTITY

function refreshCart(cart, lineID, quantity, parent) {
  const updated_quantity = cart.items[lineID - 1].quantity;
  const warning =
    '<p class="warning small text-secondary d-inline-block m-0 text-uppercase"> Total disponible:' +
    updated_quantity +
    "</p>";
  const totalItems =
    '<div class="total-items mt-auto mx-auto avenir-bold"> Total (<span class="qty">' +
    updated_quantity +
    "</span>) </div>";
  const totalItemsAmount =
    '<div class="total avenir-bold mt-auto mx-auto">' +
    currencyFormat(cart.items[lineID - 1].original_line_price) +
    "</div>";

  $(".cart-count").text(cart.item_count);
  $(".cart-total-amount").text(currencyFormat(cart.total_price));
  if (quantity > 0 && quantity > updated_quantity) {
    parent.find(".warning").remove();
    parent.find(".variant").after(warning);
    parent.find(".qty").val(updated_quantity);
    parent.find(".qtyplus").css("visibility", "hidden");
  } else {
    parent.find(".qtyplus").css("visibility", "visible");
    parent.find(".warning").remove();
  }
  if (updated_quantity > 1) {
    parent.find(".total-items").remove();
    parent.find(".qty-selector").after(totalItems);
    parent.find(".total").remove();
    parent.find(".price").after(totalItemsAmount);
  } else {
    parent.find(".total").remove();
    parent.find(".total-items").remove();
  }
}

function ajaxUpdateCart(lineID, quantity, parent) {
  $.ajax({
    url: "/cart/change.js",
    dataType: "json",
    type: "post",
    data: {
      quantity: quantity,
      line: lineID
    },
    success: function (data) {
      refreshCart(data, lineID, quantity, parent);
    },
    error: function (ms, textStatus, errorThrown) {
      console.log(errorThrown);
    }
  });
}

$(".qty-selector .btn").on("click touchstart", function (evt) {
  const $button = $(this);
  const $quantity = $button.parents(".qty-selector").find(".qty");
  const max = 15;
  const oldValue = parseInt($quantity.val(), 10);
  let newVal;

  evt.preventDefault();

  if ($button.hasClass("qtyplus")) {
    newVal = oldValue + 1;
  }

  if ($button.hasClass("qtyminus")) {
    newVal = oldValue - 1;
  }

  newVal = Math.min(max, Math.max(1, newVal));
  $quantity.val(newVal).change();
});

$(document).on("change", "#cart_form .qty", function () {
  ajaxUpdateCart(
    $(this).data("line-id"),
    $(this).val(),
    $(this).parents(".cart-shoping-item")
  );
});

// NUESTRAS TIENDAS

if (document.body.className.match("nuestras-tiendas")) {
  var _latitude = -36.9300982;
  var _longitude = -72.663172;
  var isMobile = window.matchMedia("(min-width: 767px)");
  console.log(isMobile);

  var jsonPath = [{
      id: 1,
      category: "tienda",
      title: "Patagonia Alto Las Condes ",
      location: "Av. Presidente Kennedy 9001, Local 3024",
      latitude: -33.390144,
      longitude: -70.546309,
      city: "Región Metropolitana",
      telephone: "+56222168420",
      schedule: "Lunes a Domingo: 10am a 9pm",
      place_id: "ChIJxTFrObTOYpYRVmoP1EErZNA"
    },
    {
      id: 2,
      category: "tienda",
      title: "Patagonia Portal La Dehesa",
      location: "Av. La Dehesa 1445, Local 2074",
      latitude: -33.356971,
      longitude: -70.514665,
      city: "Región Metropolitana",
      telephone: "+56222168420",
      schedule: "Lunes a Domingo: 10am a 9pm",
      place_id: "ChIJk7mTjefLYpYRuXIAOSArNLs"
    },
    {
      id: 3,
      category: "tienda",
      title: "Patagonia Mall Sport",
      location: "Av. Las Condes 13451, Local 225",
      latitude: -33.370481,
      longitude: -70.507334,
      city: "Región Metropolitana",
      telephone: "+56229558300",
      schedule: "Lunes a Domingo: 10am a 9pm",
      place_id: "ChIJHRDfOPLLYpYRDgS1p5l4DsY"
    },
    {
      id: 4,
      category: "tienda",
      title: "Patagonia Outlet Buenaventura",
      location: "San Ignacio 500, Local 12H",
      latitude: -33.3312434,
      longitude: -70.70491679999999,
      city: "Región Metropolitana",
      telephone: "+56226177522",
      schedule: "Lunes a Domingo: 10am a 8pm",
      place_id: "ChIJ2wJIr1DHYpYRjy660q7bjhk"
    },
    {
      id: 5,
      category: "tienda",
      title: "Patagonia Concepción",
      location: "Av. Jorge Alessandri 3177, Local F-114 / F116",
      latitude: -36.7973682,
      longitude: -73.0677395,
      city: "Región del Bío Bío",
      telephone: "+56452563839",
      schedule: "Lunes a Domingo: 10:00am a 10:30pm",
      place_id: "ChIJe8H3kiS1aZYRAvrtzi-1vC0"
    },
    {
      id: 6,
      category: "tienda",
      title: "Patagonia Pucón",
      location: "Fresia 248, Local C",
      latitude: -39.2764431,
      longitude: -71.9761884,
      city: "Región de la Araucanía",
      telephone: "+56452444482",
      schedule: "Lunes a Domingo: 10am a 8:30pm",
      place_id: "EjpGcmVzaWEgMjQ4LCBQdWNvbiwgUHVjw7NuLCBSZWdpw7NuIGRlIGxhIEFyYXVjYW7DrWEsIENoaWxlIhsSGQoUChIJAe8RVxV_FJYR_jSXIox6iwcQ-AE"
    },
    {
      id: 7,
      category: "tienda",
      title: "Patagonia Portal Temuco",
      location: "Avda. Alemania 0671, Local 3011",
      latitude: -38.7339696,
      longitude: -72.610962,
      city: "Región de la Araucanía",
      telephone: "+56452212580",
      schedule: "Domingo a Martes: 10am a 9pm - Viernes y Sábados: 10am a 10pm",
      place_id: "ChIJgfzPbg8_YpYRjW_zvoaUgaA"
    },
    {
      id: 8,
      category: "tienda",
      title: "Patagonia Puerto Varas",
      location: "San José 192",
      latitude: -41.3173924,
      longitude: -72.9828327,
      city: "Región de los Lagos",
      telephone: "+5665591433",
      schedule: "Lunes a Domingo: 10am a 8:30pm",
      place_id: "ChIJgZNiddcmGJYRFDWmE-zU5VQ"
    },
    {
      id: 9,
      category: "tienda",
      title: "Patagonia Coyhaique",
      location: "Calle Plaza 485",
      latitude: -45.5708436,
      longitude: -72.0677536,
      city: "Región de Aysén",
      telephone: "+56672583232",
      schedule: "Lunes a Sábado: 10am a 8pm - Domingos: 10am a 7pm",
      place_id: "ElRQbGF6YSA0ODUsIENveWhhaXF1ZSwgUmVnacOzbiBkZSBBeXPDqW4gZGVsIEdlbmVyYWwgQ2FybG9zIEliw6HDsWV6IGRlbCBDYW1wbywgQ2hpbGUiGxIZChQKEgk_GuNav8TyvREd9ArLN5ir-BDlAw"
    }
  ];

  function changeCity() {
    const _latitude = $(".location")
      .find(":selected")
      .data("lat");
    const _longitude = $(".location")
      .find(":selected")
      .data("lng");
    const _val = $(".location")
      .find(":selected")
      .val();
    //console.log(_val);
    if (_val == 0) {
      map.createHomepageGoogleMap(-36.9300982, -72.663172, 6, jsonPath);
    } else if (_val == "santiago") {
      map.createHomepageGoogleMap(-33.4171257, -70.5682511, 10, jsonPath);
    } else {
      map.createHomepageGoogleMap(_latitude, _longitude, 14, jsonPath);
    }
  }

  function changeCityMobile() {
    const _latitude = $(".location")
      .find(":selected")
      .data("lat");
    const _longitude = $(".location")
      .find(":selected")
      .data("lng");
    const _val = $(".location")
      .find(":selected")
      .val();
    //console.log(_val);
    if (_val == 0) {
      map.createHomepageGoogleMap(-33.9300982, -72.663172, 4, jsonPath);
    } else if (_val == "santiago") {
      map.createHomepageGoogleMap(_latitude - 0.2, _longitude, 10, jsonPath);
    } else {
      map.createHomepageGoogleMap(_latitude, _longitude, 8, jsonPath);
    }
  }

  // To media queries
  (function (window, document) {
    ("use strict");
    var mediaQuery = window.matchMedia("(min-width: 767px)");

    function doSomething(mediaQuery) {
      if (mediaQuery.matches) {
        $(document).on("click", ".filter-map", function (e) {
          e.preventDefault();
          changeCity();
        });
      } else {
        $(document).on("click", ".filter-map", function (e) {
          e.preventDefault();
          changeCityMobile();
        });
      }
    }
    doSomething(mediaQuery);
    mediaQuery.addListener(doSomething);
  })(window, document);

  function initialize(_latitude, _longitude, zoom, jsonPath, isMobile) {
    if (isMobile.matches) {
      map.createHomepageGoogleMap(_latitude, _longitude, zoom, jsonPath);
    } else {
      map.createHomepageGoogleMap(_latitude - 13, _longitude, 4, jsonPath);
    }
  }

  initialize(_latitude, _longitude, 6, jsonPath, isMobile);
}

// ancla tipo

$("a#ver-video").click(evt => {
  //console.log("clicked");
  evt.preventDefault();

  var $video = $(".product-video:visible");

  if (!$video.length) return console.log;

  const videoEl = $video[0];
  const rect = videoEl.getBoundingClientRect();
  const position = rect.top + window.scrollY;
  window.scrollTo(0, position);
  evt.preventDefault();
  evt.stopPropagation();
});



// WEBPACK FOOTER //
// ./src/scripts/index.js